<template>
  <div >
    <div v-for="(
                  item,
                  index
                ) of content" :key="index">
        <span class="my-2 text-xs columns font-weight-bold">{{ item.ean }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: "ShipmentPackageContent",
  components: {
  },
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  methods: {
  },
};

</script>

<style scoped>

  .columns {
    max-width: 150px;
  }

</style>